import axios from "axios";

const API = axios.create({
  baseURL: "https://apiwallet.saumiccraft.com",
  withCredentials: true,
});

export default API;
